import type { FeaturesContent } from "../types";

export const features: FeaturesContent = {
  title: "Same workspace, models included.",
  lead:
    "The same UCloud project now holds your data, your compute, and the " +
    "models you run against them, chat or API, from first experiment to " +
    "production workload.",
  screenshots: [
    {
      title: "Inference playground",
      description:
        "A simple chat interface with immediate access to every model in the catalog. Try prompts, compare responses, and stream results, then take the same models to production through the OpenAI-compatible API.",
      frameAriaLabel: "Inference playground screenshot",
      mockupAriaLabel: "Inference playground mockup",
    },
    {
      title: "Compute workspace",
      description:
        "Move from an interactive session to scheduled jobs on shared GPU capacity. Models, data, storage, and applications stay together in one UCloud project.",
      frameAriaLabel: "Compute workspace screenshot",
      mockupAriaLabel: "Compute workspace mockup",
    },
    {
      title: "No sign-up. Just sign in.",
      description:
        "Your university login is the only credential, the same one you use for everything else. No accounts to create, no API keys, no procurement. The models are already part of your workspace.",
      frameAriaLabel: "No sign-up. Just sign in. screenshot",
      mockupAriaLabel: "University login mockup",
    },
  ],
};
